@import 'styles/mixins';
@import 'styles/blaze/mixins';

.newsletterPreviewContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: 20px;
  border: 1px solid var(--dark-10);
  overflow: hidden;
  width: 100%;

  @include for-phone-only {
    @include content-preview-card-shadow;
    border-radius: 8px;
    border: 1px solid var(--dark-8);
    background: #fff;
    height: 100%;
    min-height: 0;
  }

  &.isActive {
    .newsletterPreview {
      background: initial;
    }
  }

  .newsletterPreviewHeader {
    display: flex;
    width: 100%;
    padding: 20px 17px 10px 17px;
    flex-direction: column;
    align-items: flex-end;
    gap: 15px;
    background: var(--light-100);
    border-radius: 20px 20px 0 0;

    .titleContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .title {
        @include line-clamp(1);
        color: var(--Dark-80, rgba(0, 0, 0, 0.8));
        text-overflow: ellipsis;
        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%; /* 20px */
        letter-spacing: -0.4px;
        padding-bottom: 2px;

        @include for-desktop-only {
          max-width: 660px;
        }
      }

      .inbox {
        color: var(--Dark-60, rgba(0, 0, 0, 0.6));
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 16.8px */
        letter-spacing: -0.24px;
        width: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        background: var(--dark-8);
      }
    }

    .subjectContainer {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 16px;
      width: 100%;

      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;

        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .emailSubject {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .subjectLine {
          display: flex;
          align-items: center;
          gap: 5px;

          .subject {
            color: var(--dark-80);
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 0%; /* 0 */
          }
        }
      }

      .email,
      .toMe {
        color: var(--dark-40);
        font-family: Inter;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 16.8px */
        letter-spacing: -0.24px;
        display: flex;
        align-items: center;
        gap: 2px;

        svg {
          fill: var(--dark-40);

          path {
            stroke: transparent;
          }
        }
      }
    }
  }

  .newsletterPreview {
    padding: 25px 0px 0 0px;
    background: var(--dark-3);

    [data-autopilot-system-redesign='on'] & {
      padding-top: 0;
    }

    @include for-phone-only {
      padding: 0;
      max-height: 100%;
      flex: 1 1 auto;
      min-height: 0;
      width: 100%;
      display: flex;
    }
  }
}
